module.exports = __webpack_public_path__ + "img/george-jones.1cf62c38.png";